import React from 'react'
import PropTypes from 'prop-types'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import PortraitIcon from './PortraitIcon'

const styleSheet = {
    viewInPortraitMode: {
        fontSize: 20,
        fontWeight: 500,
        width: '70%',
        textAlign: 'center',
        color: '#ffffff',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
    },
}

const style = injectJss(styleSheet)

const ViewInPortraitMode = ({ classes, message, onClick }) => (
    <div className={classes.viewInPortraitMode} onClick={onClick}>
        <PortraitIcon />
        {message}
    </div>
)

ViewInPortraitMode.defaultProps = {
    message: 'For an Optimal Experience on this device, please view in Portrait Mode',
}

ViewInPortraitMode.propTypes = {
    message: PropTypes.string,
}

export default compose(
    style,
    pure
)(ViewInPortraitMode)
